import type { UpdateBadgeAction } from '../components/ActivityFeedActions';
import loadActivityFeed from './loadActivityFeed';
import { getUnseenItemsCount } from '../store/unseenItemsSelector';
export const pollActivityFeed = (isOpx?: boolean, updateBadgeCountAction?: UpdateBadgeAction) => {
    if (isOpx && updateBadgeCountAction) {
        setInterval(() => {
            loadActivityFeed().then(() => {
                updateBadgeCountAction.updateBadge(getUnseenItemsCount());
            });
        }, 300000); // Setinterval to 5 minutes
    }
};
